<script lang="ts">
import type { Card } from '$types/card';

interface Props {
  card: Card;
}

const { card }: Props = $props();
const prompt = $derived(card.self_explain?.prompt);
const rubric = $derived(card.self_explain?.rubric ?? []);
let showRubric = $state(false);
</script>

{#if prompt}
  <section class="self-explain">
    <div class="se-label">↳ self-explain · 30s laut sprechen (bisra)</div>
    <p class="prompt">{prompt}</p>
    {#if rubric.length}
      <button type="button" class="rule-btn" onclick={() => (showRubric = !showRubric)}>
        {showRubric ? '− rubric verbergen' : '+ rubric einblenden'}
      </button>
      {#if showRubric}
        <ul class="rubric">{#each rubric as item}<li>{item}</li>{/each}</ul>
      {/if}
    {/if}
  </section>
{/if}

<style>
  .self-explain {
    margin-top: 12px;
    padding: 12px;
    border: 1px dashed var(--accent);
    background: var(--paper-2);
    position: relative;
  }
  .self-explain::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: repeating-linear-gradient(
      45deg, transparent 0 6px, rgba(232, 81, 28, 0.04) 6px 7px
    );
    pointer-events: none;
  }
  .se-label {
    font-size: 10px;
    letter-spacing: 0.12em;
    color: var(--accent-2);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .prompt {
    font-family: var(--font-body), 'Inter';
    font-style: italic;
    color: var(--ink-2);
    margin: 0 0 8px;
    font-size: 13px;
    line-height: 1.5;
  }
  .rule-btn {
    background: transparent;
    border: 1px solid var(--rule);
    padding: 3px 8px;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-2);
    cursor: pointer;
  }
  .rule-btn:hover { background: var(--paper-3); }
  .rubric {
    margin: 6px 0 0 1rem;
    font-size: 11px;
    color: var(--ink-2);
  }
</style>
